<template>
    <div>
		<el-card class="box-card" v-if="detailData" v-loading="listLoading">
			<div slot="header" class="clearfix">
				<span>
					<span class="el-icon-data-line"></span> 用户与优惠券
				</span>
			</div>
			<table class="info-table" width='100%'>
				<tr>
					<th></th>
					<th>用户总数</th>
					<th>新用户数</th>
					<th>新用户转化率</th>
					<th>未领取优惠券</th>
					<th>领取了优惠券</th>
					<th>未使用优惠券</th>
					<th>使用了优惠券</th>
				</tr>
				<tr>
					<td>发起活动的用户</td>
					<td>{{detailData.launchUser.userTotalNum}}</td>
					<td>{{detailData.launchUser.newUserTotalNum}}</td>
					<td>{{detailData.launchUser.newUserRate}}</td>
					<td>{{detailData.launchUser.notGotCoupon}}</td>
					<td>
						<p>数量：{{detailData.launchUser.gotCoupon}}</p>
						<p>金额：{{detailData.launchUser.gotCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.launchUser.notUsedCoupon}}</p>
						<p>金额：{{detailData.launchUser.notUsedCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.launchUser.usedCoupon}}</p>
						<p>有效金额：{{detailData.launchUser.validCouponAmountStr}}</p>
						<p>无效金额：{{detailData.launchUser.inValidCouponAmountStr}}</p>
					</td>
				</tr>
				<tr>
					<td>参与活动的用户</td>
					<td>{{detailData.joinUser.userTotalNum}}</td>
					<td>{{detailData.joinUser.newUserTotalNum}}</td>
					<td>{{detailData.joinUser.newUserRate}}</td>
					<td>{{detailData.joinUser.notGotCoupon}}</td>
					<td>
						<p>数量：{{detailData.joinUser.gotCoupon}}</p>
						<p>金额：{{detailData.joinUser.gotCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.joinUser.notUsedCoupon}}</p>
						<p>金额：{{detailData.joinUser.notUsedCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.joinUser.usedCoupon}}</p>
						<p>有效金额：{{detailData.joinUser.validCouponAmountStr}}</p>
						<p>无效金额：{{detailData.launchUser.inValidCouponAmountStr}}</p>
					</td>
					
				</tr>
				<tr>
					<td>总用户数（去重）</td>
					<td>{{detailData.totalUser.userTotalNum}}</td>
					<td>{{detailData.totalUser.newUserTotalNum}}</td>
					<td>{{detailData.totalUser.newUserRate}}</td>
					<td>{{detailData.totalUser.notGotCoupon}}</td>
					<td>
						<p>数量：{{detailData.totalUser.gotCoupon}}</p>
						<p>金额：{{detailData.totalUser.gotCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.totalUser.notUsedCoupon}}</p>
						<p>金额：{{detailData.totalUser.notUsedCouponAmountStr}}</p>
					</td>
					<td>
						<p>数量：{{detailData.totalUser.usedCoupon}}</p>
						<p>有效金额：{{detailData.totalUser.validCouponAmountStr}}</p>
						<p>无效金额：{{detailData.launchUser.inValidCouponAmountStr}}</p>
					</td>
				</tr>
								
			</table>
		</el-card>
		<el-card class="box-card MT20" v-if="detailData && detailData.activityStatistics" v-loading="listLoading">
			<div slot="header" class="clearfix">
				<span>
					<span class="el-icon-data-line"></span> 膨胀红包演出使用详情
				</span>
			</div>
			<table class="info-table" width='100%'>
				<tr>
					<th>演出id</th>
					<th>演出名称</th>
					<th>使用人数</th>
					<th>使用红包下单总金额</th>
					<th>演出下单总金额</th>
				</tr>
				<template v-if="detailData && detailData.activityStatistics.detailList">
					<tr v-for="(item, index) in detailData.activityStatistics.detailList" :key="index" >
						<td>{{item.activityId}}</td>
						<td>{{item.activityName}}</td>
						<td>{{item.userNum}}</td>
						<td>{{item.couponTotalAmountView}}</td>
						<td>{{item.totalAmountView}}</td>
					</tr>
				</template>
				<tr>
					<td>汇总</td>
					<td></td>
					<td>{{detailData.activityStatistics.userNum}}</td>
					<td>{{detailData.activityStatistics.couponTotalAmountView}}</td>
					<td>{{detailData.activityStatistics.totalAmountView}}</td>
				</tr>
			</table>
		</el-card>
		<template>
			<el-card class="box-card MT20">
				<div slot="header" class="clearfix">
					<span>
						<span class="el-icon-data-line"></span> 地区分布 <span class="color-danger">（按用户最近登录所在地进行统计）</span>
					</span>
				</div>
				<div class="page-list-box" v-if="data && data.provinceList">				
					<el-table :data="data.provinceList.slice((currentPage - 1) * pagesize, currentPage * pagesize)" border style="width: 100%"  size="small" stripe v-loading="dataLoading">
						<el-table-column prop="name" label="省份"></el-table-column>               
						<el-table-column prop="num" label="人数"></el-table-column>
						<el-table-column prop="ratio" label="占比"></el-table-column>
					</el-table>
					<div v-if="data && data.provinceList" class="page-pagination-box MT20">
						<el-pagination
							  @size-change="handleSizeChange"
							  @current-change="handleCurrentChange"
							  :current-page="currentPage"
							  :page-sizes="[5, 10, 15, 20]"
							  :page-size="pagesize"
							  layout="total, sizes, prev, pager, next, jumper"
							  :total="data.provinceList.length">
						</el-pagination>
					</div>
				</div>
				<div class="page-list-box" v-if="data && data.cityList">
					<el-table :data="data.cityList.slice((currentPage2 - 1) * pagesize2, currentPage2 * pagesize2 )" border style="width: 100%"  size="small" stripe>
						<el-table-column prop="name" label="城市"></el-table-column>               
						<el-table-column prop="num" label="人数"></el-table-column>
						<el-table-column prop="ratio" label="占比"></el-table-column>
					</el-table>
					<div v-if="data && data.cityList" class="page-pagination-box MT20">
						<el-pagination
							  @size-change="handleSizeChange2"
							  @current-change="handleCurrentChange2"
							  :current-page="currentPage2"
							  :page-sizes="[5, 10, 15, 20]"
							  :page-size="pagesize2"
							  layout="total, sizes, prev, pager, next, jumper"
							  :total="data.cityList.length">
						</el-pagination>
					</div>
				</div> 			
			</el-card>
		</template>
		<el-card class="box-card MT20" v-if="data && data.ageList" >
			<div slot="header" class="clearfix">
			    <span>
			        <span class="el-icon-data-line"></span> 年龄段分布 
			    </span>
			</div>
			<div id="ageChart"></div>
		</el-card>
		<el-card class="box-card MT20" v-if="data && data.sexRatio">
			<div slot="header" class="clearfix">
			    <span>
			        <span class="el-icon-data-line"></span> 性别分布 
			    </span>
			</div>
			<div id="sexChart"></div>
		</el-card>
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    components:{},
	props:{
	    id: {
	        type: [Number, String],
	        default: ""
	    }
	},
    data(){
        return{
            data: null,
            detailData:null,
            listLoading: true,
			dataLoading: true,
			chart1: null,
			chart2: null,
			currentPage: 1, //初始页
			pagesize: 10, // 每页的数据
			currentPage2: 1, //初始页
			pagesize2: 10, // 每页的数据

        }
    },
    mounted() {
        this.getDataList();
		this.getCoupon()
    },
    methods: {
        //获取列表
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: "/expand/userPortrait",
                method: "POST",
                params: {
					id:this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					
					this.$nextTick(() => {
						this.drawChart();
						this.drawChart1();
						
					})
                    
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.dataLoading = false;
			});			
        },
		handleSizeChange (size) {		        
			this.pagesize = size;
		},
		handleCurrentChange (currentPage) {
			this.currentPage = currentPage;
		},
		handleSizeChange2 (size2) {
		    this.pagesize2 = size2;
		},
		handleCurrentChange2 (currentPage2) {			
		    this.currentPage2 = currentPage2;
		},
		getCoupon(){
		    this.listLoading = true   
		    this.$request({
		        url: "/expand/statistics",
		        method: "POST",
		        params: {
		            id: this.id
		        },
		    })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {					 
					this.detailData = result;
					
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});	
		},
		//年龄
		drawChart(){
		    if( this.chart1 ) this.chart1.destroy();
		    let _data = this.data.ageList
		    _data.map( v => {
		        v.num = parseFloat(v.num)
		    })
			
		    this.chart1 = new Chart({
		        container:'ageChart',
		        autoFit: true,
		        height: 200,
		    });
		    this.chart1.data(_data);
		    this.chart1.interaction('active-region'); 
		   
			this.chart1.tooltip({
			        showTitle: false,//不显示标题
			        showMarkers: false,//不显示贴敷上去的小点
			        position: "right",//显示位置			       
			        itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
			      });			 
			   this.chart1.interval().position("name*num").tooltip("name*num*ratio", function (name, num ,ratio) {
			          return { name, num ,ratio};
			    });
			this.chart1.render();
		},
		//性别
		drawChart1(){
		    if( this.chart2 ) this.chart2.destroy();
			
		    let _data = [];
		    _data = [...this.data.sexRatio];
			_data.map( v => {
			    v.percent = v.num
			})
			_data = _data.filter( v => v.num > 0 );
			
			
		    this.chart2 = new Chart({
		        container: 'sexChart',
		        autoFit: true,
		        height: 420,				
		    });
			this.chart2.coordinate('theta', {
			    radius: 0.6,
			});
			
		    this.chart2.data(_data);
			this.chart2.scale('percent', {
			    formatter: (val) => {
			        val = (val * 100).toFixed(2) + '%';
			        return val;
			    },
			});
			
			this.chart2.tooltip({
			    showTitle: false,
			    showMarkers: false,
			});
			
			this.chart2.legend('name', {
			    position: 'top',
			});
			this.chart2
			    .interval()
			    .adjust('stack')
			    .position('percent')
			    .color('name')
			    .label('percent', (val) => {
			        return {
			            // offset: val > 0.05 ? -30 : null,
			            content: (obj) => {
			                return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
			            },
			        };
			    })
			    .tooltip('name*num*ratio', (name, num, ratio) => {
			      
			        return {
			            name: name,
						num:num,
			            value: num,
			        };
			    });
			
			
			this.chart2.render();
		},
       
    }
}
</script>

<style lang="scss" scoped>
.blue{
   color:#409eff;
   text-decoration:none;
}
.info-table td{
	border-right: 1px solid #eee;
}
</style>